import { Button as AntButton } from 'antd';
import './Button.scss';

/**
 * One button for the whole app. Every variant is a real Figma node, with that
 * node's exact geometry; nothing about it is themed globally, so the design
 * can't be overridden from ConfigProvider.
 *
 *   pill       1:9952   105° #1A5DFD→#103897 · 27.2h · px9  · r5  · 11.2/400 · #fff
 *   toolbar    1:11799  #161616              · 32h   · px10 · r7  · 11.2/400 · #b0b0b0
 *   ghost      1:34273  #0E0E0E              · 40h   · px14 · r12 · 13/400   · #F7F8F8
 *   action     1:34275  180° indigo          · 40h   · px16 · r10 · 13/500   · #C5CFFD
 *   actionAlt  1:34277  180° indigo          · 40h   · px14 · r8  · 13/400   · #C5CFFD
 *   submit     1:33268  180° #004BFF→#255AD9 · 38h   · px16 · r5  · 12/300   · #fff
 *   auth       1:3791   105° #0D56EB→#0640B9 · 44h   · px6  · r5  · 14/400   · #fff
 *   light      1:7824   #fff                 · 34h   · —    · r10 · 11/400   · #111
 *
 * `height` and `paddingInline` are props because the design reuses one fill at
 * several sizes — the pill is 27.2h/px9 as "View all analytics" (1:9952) and
 * 28.8h/px16 as "Open" (1:8087).
 */
export default function Button({
  variant = 'ghost',
  height,
  paddingInline,
  className = '',
  style,
  ...rest
}) {
  const sized =
    height != null || paddingInline != null
      ? {
          ...(height != null && { height: typeof height === 'number' ? `${height}px` : height }),
          ...(paddingInline != null && {
            paddingInline: typeof paddingInline === 'number' ? `${paddingInline}px` : paddingInline,
          }),
        }
      : null;

  return (
    <AntButton
      {...rest}
      variant="solid"
      color="default"
      className={`ac-btn ac-btn--${variant} ${className}`.trim()}
      style={{ ...sized, ...style }}
    />
  );
}
